export default {
	tabs: ["入金", "履歴"],
	History: {
		tabs: ["審査中", "成功", "却下"]
	},
	AccountAmount: "口座残高",
	ContactCustomerService: "カスタマーサービスに連絡",
	NoCustomerService: "カスタマーサービスがビジー",
	tips: "次の評価を進める前に、前の評価を提出してください。"
};
